import { IBarGraphContent } from "@ryde/shared";

import { TValueFormatter } from "./dashboard-card-data.models";

export const EMPTY_CONTENT: IBarGraphContent = { entities: [] };

export const defaultValueFormatter: TValueFormatter = value =>
  Number(value).toLocaleString();
